module.exports = __webpack_public_path__ + "static/media/edit.8267ccb4.svg";